import { createSelector } from 'reselect';

import type { SortOrder } from '@iconik-io/shared-lib/src/utils/sort/types';

import type { AppState } from '../../store/types';
import { CUSTOM_ORDER_NAME } from './sorting_selector/constants';

const getSortingItems = (state: AppState) => state.pages.search.list.sort;

export const selectSortDirectionMap = createSelector(
  getSortingItems,
  (sortingItems) =>
    new Map<string, SortOrder>(
      sortingItems.map((sortItem) => [sortItem.name, sortItem.order]),
    ),
);

export const selectIsCurrentSortCustom = createSelector(
  selectSortDirectionMap,
  (sortingItems) => {
    const keys = [...sortingItems.keys()];
    return keys.length === 1 && keys[0] === CUSTOM_ORDER_NAME;
  },
);
